<div class="create-page  mb-5">
    <div class="zoom-wrapper">
        <div class="container main">
            <app-breadcrumb [breadcrumbs]="currentBreadcrumb"></app-breadcrumb>
            <div class="d-flex align-items-center justify-content-center top">
                <img src="/footer-amico.png" alt="Login Illustration" class="login-illustration mb-3 footer-img" />
            </div>
            <div class="main-heading d-flex justify-content-center align-items-center flex-column">
                <h5>Welcome! Please enter your email address</h5>
                <p class="m-0">Enter Your Email and we will help to create your password.</p>
            </div>
            <form class="forget-form">
                <div class="form-group d-flex flex-column">
                    <label for="email" class="form-label">Email:</label>
                    <input id="email" name="email" type="email" class="form-control" [(ngModel)]="email"
                        autocapitalize="off" autocorrect="off">
                </div>
                <div class="create-btn text-center" (click)="createPasswordLink()"><button>Continue</button></div>
            </form>
        </div>
    </div>
</div>